<script>
  import AddBlock from "./AddBlock.svelte";
  import StepBlock from "./StepBlock.svelte";
  import { clickForStepSettings, makeId } from "../static";
  import WhereToBranch from "../Popups/WhereToBranch.svelte";
  import EndBlock from "./EndBlock.svelte";
  import {External, M} from "../../external";

  export let data;
  export let automation;
  export let automationSave;
  export let rootFlow = false;

  let cmps = [];

  const onClick = (step) => {
    if (step && step.type && hasSettings(step)) {
      clickForStepSettings(step.type, step, null, onUpdate, null, null, automation, step.id, automationSave);
    }
  };

  const hasSettings = (step) => {
    switch (step.type) {
      case "CONTACT_DELETE":
      case "CONTACT_UNSUBSCRIBE":
        return false;
    }
    return true;
  };

  const onUpdate = (step) => {
    if (!step.waiting) {
      step.waiting = 0;
    }

    if (!step.completed) {
      step.completed = 0;
    }

    let index = 0;
    let count = 0;
    for (let count = 0; count < data.length; count++) {
      if (data[count].id === step.id) {
        index = count;
      }
    }
    data[index] = step;
  };

  const onAdd = (newStep) => {
    if (!newStep.id || newStep.id.length == 0) {
      if (newStep.reservedId) {
        newStep.id = newStep.reservedId;
        delete newStep.reservedId;
      } else {
        newStep.id = makeId(10);
      }
      newStep.waiting = 0;
      newStep.completed = 0;
      newStep.stickyNotes = [];

      if (!data) data = [];

      let prevSteps = data.slice(0, newStep.order);
      let nextSteps = data.slice(newStep.order, data.length);
      for (let step of nextSteps) {
        step.order = step.order + 1;
      }
      newStep.order = newStep.order + 1;

      data = [...prevSteps, newStep, ...nextSteps];
    }
    return newStep.id;
  };

  const onRemove = (index) => {
    External.Tools.prompt(M.DELETE, M.DELETE_STEP_Q, function () {
      let dontTouch = data.slice(0, index);
      let toDecrease = data.slice(index + 1, data.length);
      for (let step of toDecrease) {
        step.order = step.order - 1;
      }

      data = [...dontTouch, ...toDecrease];
    });
  };

  const onMoveUp = (index) => {
    let dontTouchUp = data.slice(0, index - 1);
    let dontTouchDown = data.slice(index + 1, data.length);

    let up = data[index - 1];
    up.order = up.order + 1;

    let down = data[index];
    down.order = down.order - 1;

    data = [...dontTouchUp, down, up, ...dontTouchDown];
  };

  const onMoveDown = (index) => {
    if (data[index + 1] && data[index + 1].type !== "IF_ELSE" && data[index + 1].type !== "SPLIT") {
      let dontTouchUp = data.slice(0, index);
      let dontTouchDown = data.slice(index + 2, data.length);

      let up = data[index];
      up.order = up.order + 1;

      let down = data[index + 1];
      down.order = down.order - 1;

      data = [...dontTouchUp, down, up, ...dontTouchDown];
    } else {
      const buttons = [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, function (popup) {
          let choice = popup.component().get();
          if (choice == 1 || choice == 2) {
            let dontTouchUp = data.slice(0, index);
            let dontTouchDown = data.slice(index + 1, data.length);
            let up = data[index];
            let split = data[index + 1];

            data = [...dontTouchUp, ...dontTouchDown];

            let newData = choice === 1 ? split.subflowA : split.subflowB;
            for (let st of newData) {
              st.order = st.order + 1;
            }
            up.order = 1;

            newData = [up, ...newData];

            if (choice === 1) {
              split.subflowA = newData;
            } else {
              split.subflowB = newData;
            }
          }

          popup.close();
        }),
        External.Button.MIDDLE_CANCEL
      ];

      External.Tools.showWindow({
        isModal: false,
        title: M.WHERE,
        width: 500,
        buttons: buttons,
        markup: '<div class="popup-widget-wrapper"></div>',
        action: {
          onShow: function (popup, context) {
            popup.bindComponent(
              new WhereToBranch({
                target: context.find(".popup-widget-wrapper")[0],
                props: {
                  data: {}
                }
              })
            );
          }
        }
      });
    }
  };

  $: cmps = cmps.filter((el) => el);
</script>

<AddBlock onAdd={onAdd} order={0} length={data.length} automation={automation} automationSave={automationSave} />
{#if data.length > 0}
  {#each data as step, index (step.id)}
    <StepBlock
      bind:this={cmps[index]}
      bind:data={step}
      onClick={() => onClick(step)}
      onRemove={() => onRemove(index)}
      onMoveUp={step.type !== "IF_ELSE" && step.type !== "SPLIT" && data.length > 1 && index > 0 ? () => onMoveUp(index) : null}
      onMoveDown={step.type !== "IF_ELSE" && step.type !== "SPLIT" && data.length > 1 && index < data.length - 1 ? () => onMoveDown(index) : null}
      automation={automation}
      automationSave={automationSave}
      stepId={step.id} />
    {#if step.type !== "IF_ELSE" && step.type !== "SPLIT"}
      <AddBlock onAdd={onAdd} order={index + 1} length={data.length} automation={automation} automationSave={automationSave} />
      {#if index === data.length - 1}
        <EndBlock bind:data={data.end} />
      {/if}
    {/if}
  {/each}
{:else if !rootFlow}
  <EndBlock bind:data={data.end} />
{/if}
